import { ArrowLeft, ArrowUpRight, Check, Clock3, MessageCircle, UsersRound } from "lucide-react";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import "@/App.css";

const MembershipPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "9-Lesson Private Acceleration Bundle ($390/mo) | MyEnglish Lesson.ca";
    description?.setAttribute("content", "Build maximum 1-on-1 English immersion with 9 full private lessons every month at $390/month locked-in.");
    return () => {
      document.title = previousTitle;
      if (description && previousDescription) description.setAttribute("content", previousDescription);
    };
  }, []);

  const goToBookings = () => {
    window.location.href = "/#booking-section";
  };

  return (
    <div className="membership-page" id="membership-top">
      <Header homePrefix="/" onBook={goToBookings} />
      <main>
        <section className="membership-hero" aria-labelledby="membership-title">
          <div className="membership-shell">
            <Reveal className="membership-hero-copy">
              <a className="membership-back-link" href="/#top" data-testid="membership-back-home-link"><ArrowLeft size={15} /> Back to MyEnglish Lesson.ca</a>
              <div className="section-kicker">PRIVATE ACCELERATION · 1-ON-1 IMMERSION</div>
              <h1 id="membership-title">9-Lesson Private Acceleration Bundle <span>$390/mo locked-in</span></h1>
              <p>Maximum 1-on-1 immersion at $43.33 per lesson, saving over 21% off the standard $55 private rate. Receive 9 full private lessons every month with a locked-in $390/month rate.</p>
              <a className="button button-crimson membership-primary-cta" href="https://buy.stripe.com/your-link" target="_blank" rel="noopener noreferrer" data-testid="membership-activate-button">
                Secure Your Private Bundle <ArrowUpRight size={17} />
              </a>
              <p className="membership-payment-note">MOCKED PLACEHOLDER · Replace the link above with your final Stripe Payment Link before launch.</p>
            </Reveal>
            <Reveal className="membership-hero-card" delay={120}>
              <div className="membership-card-mark">$390</div>
              <div className="membership-card-label">MONTHLY COMMITMENT</div>
              <h2>More practice.<br />Less friction.</h2>
              <div className="membership-card-divider" />
              <div className="membership-card-stat"><strong>9</strong><span>Private Lessons per month</span></div>
              <div className="membership-card-stat"><strong>$43.33</strong><span>locked-in value per lesson</span></div>
            </Reveal>
          </div>
        </section>
        <section className="membership-details section-space" aria-labelledby="membership-details-title">
          <Reveal className="section-inner membership-details-inner">
            <div>
              <div className="section-kicker">WHAT YOU GET</div>
              <h2 id="membership-details-title">A better way to keep showing up.</h2>
              <p>One simple monthly commitment for learners who want momentum, access, and a direct line to their tutor.</p>
            </div>
            <div className="membership-feature-list">
              <div><UsersRound size={20} /><div><h3>9 private lessons per month</h3><p>Receive full 1-on-1 coaching every month at $43.33 per lesson, versus the standard $55 private rate.</p></div></div>
              <div><Clock3 size={20} /><div><h3>Priority booking access</h3><p>Choose the sessions that fit your schedule before spaces fill.</p></div></div>
              <div><MessageCircle size={20} /><div><h3>Direct instructor support</h3><p>Keep questions, feedback, and next steps moving between lessons.</p></div></div>
              <div><Check size={20} /><div><h3>Private-only bundle</h3><p>The Class Pass $20 reward does not apply to the 9-Class Private Pass Bundle.</p></div></div>
            </div>
          </Reveal>
        </section>
      </main>
      <Footer homePrefix="/" />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
};

export default MembershipPage;
